/* Wynden Home redesign: motion for the wh-rd-* sections.
   Ported from the approved prototype. Each component starts from its own section root, so sections can be
   added, removed and re-ordered in the theme editor (it re-runs on shopify:section:load).
   Note: on wide screens Horizon scrolls .page-wrapper, not the window, so scroll is listened to on the whole
   document in the capture phase and positions always come from getBoundingClientRect. */
(function () {
  'use strict';
  var reduce = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;
  var narrow = window.matchMedia ? matchMedia('(max-width:900px)') : { matches: false };
  function esc(s) { return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function all(root, sel) { return [].slice.call(root.querySelectorAll(sel)); }
  function onScroll(fn) { document.addEventListener('scroll', fn, { passive: true, capture: true }); }

  /* ---------- one animation loop for everything that moves every frame ---------- */
  var frames = [];
  var tPrev = 0, looping = false;
  function addFrame(root, fn) { frames.push({ root: root, fn: fn, vis: !('IntersectionObserver' in window) }); watch(root); startLoop(); }
  var io = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { frames.forEach(function (f) { if (f.root === e.target) f.vis = e.isIntersecting; }); });
    startLoop();
  }, { rootMargin: '120px 0px' }) : null;
  function watch(el) { if (io) io.observe(el); }
  function startLoop() { if (!looping) { looping = true; tPrev = performance.now(); requestAnimationFrame(loop); } }
  function loop(now) {
    var dt = Math.min(4, Math.max(0.25, (now - tPrev) / 16.667)); tPrev = now;
    var any = false;
    frames = frames.filter(function (f) { return f.root.isConnected; });
    frames.forEach(function (f) { if (f.vis) { any = true; f.fn(dt); } });
    if (any) requestAnimationFrame(loop); else looping = false;
  }

  // engraving fields are one line tall while the text is one line; empty, they show the two-line example
  function fitRows(ta) { if (ta) ta.rows = (!ta.value || ta.value.indexOf('\n') >= 0) ? 2 : 1; }

  /* ---------- lightbox: one viewer for every photo and clip ----------
     Opening and closing fly the photo between its spot on the page and the viewer (FLIP). Every photo
     shows in the same square frame, so the size never jumps while you flip through. */
  var LB = null;
  // keyboard users get the focus ring; a tap or a click should not leave a box around Close or the arrows
  var kbUser = false;
  document.addEventListener('keydown', function (e) { if (e.key === 'Tab' || e.key === 'Enter' || e.key === ' ') kbUser = true; }, true);
  document.addEventListener('pointerdown', function () { kbUser = false; }, true);
  function lbBuild() {
    if (LB) return LB;
    var wrap = document.createElement('div');
    wrap.className = 'wh-rd wh-rd-lbwrap';
    wrap.innerHTML = '<div class="lb" id="lb" tabindex="-1" role="dialog" aria-modal="true" aria-label="Photo viewer" hidden><div class="lb-stage" id="lbStage"><div class="lb-box">' +
      '<div class="lb-top"><span class="lb-count"><span id="lbN">01 / 01</span><span class="lb-prog" aria-hidden="true"><i id="lbBar"></i></span></span><button type="button" class="lb-x" id="lbX">Close ✕</button></div>' +
      '<div class="lb-media"><img class="lb-img" id="lbImg" alt=""><video class="lb-img lb-vid" id="lbVid" muted loop playsinline controls preload="none" hidden></video>' +
      '<button type="button" class="lb-nav lb-prev" id="lbPrev" aria-label="Previous">←</button><button type="button" class="lb-nav lb-next" id="lbNext" aria-label="Next">→</button></div>' +
      '<p class="lb-cap" id="lbCap"></p></div></div></div>';
    document.body.appendChild(wrap);
    var q = function (id) { return wrap.querySelector('#' + id); };
    var L = LB = { wrap: wrap, el: q('lb'), img: q('lbImg'), vid: q('lbVid'), cap: q('lbCap'), n: q('lbN'), bar: q('lbBar'), stage: q('lbStage'),
      set: [], i: 0, tok: 0, ret: null, src: null, t: 0, hideT: 0, ghost: null, anim: null, onChange: [] };
    q('lbX').addEventListener('click', function () { lbClose(); });
    q('lbPrev').addEventListener('click', function () { lbShow(L.i - 1, true, -1); });
    q('lbNext').addEventListener('click', function () { lbShow(L.i + 1, true); });
    addEventListener('resize', function () { if (!L.el.hidden && L.set[L.i] && L.set[L.i].video) fitVid(L.set[L.i]); });
    // swipe: fingers go through touch events (phones may cancel pointer events mid-gesture), the mouse through pointer events
    var sw = null;
    function swStart(x, y, t) { if (t.closest && t.closest('button')) { sw = null; return; } sw = { x: x, y: y, t: t }; }
    function swEnd(x, y) {
      if (!sw) return; var dx = x - sw.x, dy = y - sw.y, t = sw.t; sw = null;
      if (Math.abs(dx) > 40 && Math.abs(dx) > Math.abs(dy)) { if (L.set.length > 1) lbShow(L.i + (dx < 0 ? 1 : -1), true, dx < 0 ? 1 : -1); }
      else if (dy > 90) lbClose();
      else if (Math.abs(dx) < 6 && Math.abs(dy) < 6 && t === L.stage) lbClose();
    }
    L.stage.addEventListener('pointerdown', function (e) { if (e.pointerType !== 'touch') swStart(e.clientX, e.clientY, e.target); });
    L.stage.addEventListener('pointerup', function (e) { if (e.pointerType !== 'touch') swEnd(e.clientX, e.clientY); });
    L.stage.addEventListener('pointercancel', function (e) { if (e.pointerType !== 'touch') sw = null; });
    L.stage.addEventListener('touchstart', function (e) { var p = e.touches[0]; if (e.touches.length === 1) swStart(p.clientX, p.clientY, e.target); else sw = null; }, { passive: true });
    L.stage.addEventListener('touchend', function (e) { var p = e.changedTouches[0]; if (p) swEnd(p.clientX, p.clientY); });
    L.stage.addEventListener('touchcancel', function () { sw = null; });
    // the page under the viewer must not scroll or bounce while you swipe
    L.el.addEventListener('touchmove', function (e) { if (!e.target.closest('video')) e.preventDefault(); }, { passive: false });
    L.img.draggable = false;
    L.img.addEventListener('dragstart', function (e) { e.preventDefault(); });
    document.addEventListener('keydown', function (e) {
      if (L.el.hidden) return;
      if (e.key === 'Escape') { e.preventDefault(); lbClose(); return; }
      if (e.key === 'ArrowRight' && L.set.length > 1) { e.preventDefault(); lbShow(L.i + 1, true); return; }
      if (e.key === 'ArrowLeft' && L.set.length > 1) { e.preventDefault(); lbShow(L.i - 1, true, -1); return; }
      if (e.key === 'Tab') {
        var f = all(L.el, 'button').filter(function (b) { return !b.hidden && b.offsetParent !== null; });
        if (!f.length) return;
        var k = f.indexOf(document.activeElement); e.preventDefault();
        f[(k + (e.shiftKey ? -1 : 1) + f.length) % f.length].focus();
      }
    });
    return L;
  }
  var FULL = 'polygon(0% 0%, 100% 0%, 100% 100%, 0% 100%)';
  function rectOf(el) { var r = el.getBoundingClientRect(); return { x: r.left, y: r.top, w: r.width, h: r.height }; }
  function onScreen(r) { return r.w > 4 && r.h > 4 && r.y < innerHeight && r.y + r.h > 0 && r.x < innerWidth && r.x + r.w > 0; }
  function clipOf(el) { var c = getComputedStyle(el).clipPath; return c && c.indexOf('polygon(') === 0 ? c : FULL; }
  function posOf(el) { var im = el.tagName === 'IMG' ? el : el.querySelector('img,video'); return im ? getComputedStyle(im).objectPosition : ''; }
  function lbMedia() { var it = LB.set[LB.i]; return it && it.video ? LB.vid : LB.img; }
  function killGhost() { if (LB.anim) { LB.anim.onfinish = null; LB.anim.cancel(); LB.anim = null; } if (LB.ghost) { LB.ghost.remove(); LB.ghost = null; } }
  function fly(from, to, src, pos, dur, done) {
    killGhost();
    var g = document.createElement('div'); g.className = 'lb-ghost';
    var im = document.createElement('img'); im.alt = ''; im.src = src; if (pos) im.style.objectPosition = pos;
    g.appendChild(im); LB.wrap.appendChild(g); LB.ghost = g;
    function kf(r) { return { width: r.w + 'px', height: r.h + 'px', transform: 'translate(' + r.x.toFixed(1) + 'px,' + r.y.toFixed(1) + 'px)', clipPath: r.clip || FULL }; }
    LB.anim = g.animate([kf(from), kf(to)], { duration: dur, easing: 'cubic-bezier(.2,.75,.2,1)', fill: 'forwards' });
    LB.anim.onfinish = function () { LB.anim = null; if (done) done(); if (LB.ghost) { LB.ghost.remove(); LB.ghost = null; } };
  }
  function fitVid(it) {
    var r = LB.stage.getBoundingClientRect(), ar = it.ar || 9 / 16;
    var maxH = Math.max(120, Math.min(r.height - 110, innerHeight - 170)), w = Math.min(r.width, innerWidth - 32), h = w / ar;
    if (h > maxH) { h = maxH; w = h * ar; }
    LB.vid.style.width = Math.round(w) + 'px'; LB.vid.style.height = Math.round(h) + 'px';
  }
  // the next photos load in the background, so the arrows switch without a dark gap
  function lbWarm(i) {
    var n = LB.set.length; if (!n) return;
    [i + 1, i - 1, i + 2].forEach(function (k) {
      var it = LB.set[(k % n + n) % n];
      if (it && !it.video && !it.pre) { it.pre = new Image(); it.pre.decoding = 'async'; it.pre.src = it.src; }
    });
  }
  function lbShow(i, animate, dir) {
    var L = LB;
    L.i = (i + L.set.length) % L.set.length;
    var it = L.set[L.i], tok = ++L.tok;
    function swap() {
      if (tok !== L.tok) return;
      if (it.video) {
        L.img.hidden = true; L.vid.hidden = false;
        L.vid.poster = it.poster || '';
        if (L.vid.getAttribute('src') !== it.src) { L.vid.src = it.src; L.vid.preload = 'auto'; }
        L.vid.setAttribute('aria-label', it.cap || 'Video');
        fitVid(it);
        L.vid.muted = !it.snd; // clips with a voice open with sound: the viewer just tapped to enlarge
        var start = function () { if (!reduce) { var p = L.vid.play(); if (p && p.catch) p.catch(function () { L.vid.muted = true; L.vid.play().catch(function () {}); }); } };
        if (L.vid.readyState >= 1) start(); else L.vid.addEventListener('loadedmetadata', start, { once: true });
      } else {
        if (!L.vid.paused) L.vid.pause();
        L.vid.hidden = true; L.img.hidden = false;
        L.img.src = it.src; L.img.alt = it.alt || '';
      }
      L.cap.textContent = it.cap || '';
      L.n.textContent = ('0' + (L.i + 1)).slice(-2) + ' / ' + ('0' + L.set.length).slice(-2);
      L.bar.style.width = (100 / L.set.length) + '%'; L.bar.style.transform = 'translateX(' + (L.i * 100) + '%)';
      if (animate && !reduce && L.img.animate) {
        var m = it.video ? L.vid : L.img, d = (dir || 1) * 26;
        m.animate([{ transform: 'translateX(' + d + 'px)', opacity: .55 }, { transform: 'none', opacity: 1 }], { duration: 260, easing: 'cubic-bezier(.2,.7,.2,1)' });
      }
      lbWarm(L.i);
    }
    // the old photo stays on screen until the new one is ready, then they change in one frame
    if (it.video || !animate) { swap(); return; }
    var pre = it.pre || (it.pre = new Image());
    if (!pre.src) pre.src = it.src;
    if (pre.complete && pre.naturalWidth) { swap(); return; }
    var go = function () { pre.removeEventListener('load', go); pre.removeEventListener('error', go); swap(); };
    pre.addEventListener('load', go); pre.addEventListener('error', go);
  }
  // srcFn(i, closing) returns the page element photo i lives in, so the viewer opens out of it and closes back into it
  function openLB(set, i, from, srcFn) {
    if (!set.length) return;
    var L = lbBuild();
    L.set = set; L.ret = from || document.activeElement; L.src = srcFn || null;
    clearTimeout(L.hideT); killGhost();
    L.img.classList.remove('flip'); L.vid.classList.remove('flip');
    L.el.hidden = false; document.documentElement.classList.add('wh-rd-lb-open');
    L.el.querySelector('#lbPrev').hidden = L.el.querySelector('#lbNext').hidden = set.length < 2;
    lbShow(i, false);
    requestAnimationFrame(function () { L.el.classList.add('show'); });
    try { (kbUser ? L.el.querySelector('#lbX') : L.el).focus({ preventScroll: true }); } catch (e) {}
    L.onChange.forEach(function (f) { f(); });
    var sEl = L.src && L.src(L.i, false), it = L.set[L.i], media = lbMedia();
    if (reduce || !sEl || !document.body.animate) return;
    var fr = rectOf(sEl); fr.clip = clipOf(sEl);
    if (!onScreen(fr)) return;
    media.classList.add('flip');
    var pos = posOf(sEl), done = false;
    function launch() {
      if (done) return; done = true;
      var to = rectOf(media);
      if (!to.w || !to.h) { media.classList.remove('flip'); return; }
      fly(fr, to, it.poster || it.src, pos, 480, function () { media.classList.remove('flip'); });
    }
    if (it.video || (L.img.complete && L.img.naturalWidth)) requestAnimationFrame(launch);
    else { L.img.addEventListener('load', launch, { once: true }); setTimeout(function () { if (!done) { done = true; media.classList.remove('flip'); } }, 900); }
  }
  function lbClose(instant) {
    var L = LB; if (!L || L.el.hidden) return;
    clearTimeout(L.hideT); killGhost(); L.tok++;
    var it = L.set[L.i], media = lbMedia(), fr = rectOf(media);
    L.el.classList.remove('show'); document.documentElement.classList.remove('wh-rd-lb-open');
    if (!L.vid.paused) L.vid.pause();
    function finish() { L.el.hidden = true; L.img.classList.remove('flip'); L.vid.classList.remove('flip'); L.onChange.forEach(function (f) { f(); }); }
    var sEl = (!instant && !reduce && L.src && document.body.animate) ? L.src(L.i, true) : null;
    if (L.ret && L.ret.focus) try { L.ret.focus({ preventScroll: true }); } catch (e) {}
    if (instant || reduce) { finish(); return; }
    if (sEl && fr.w) {
      var to = rectOf(sEl); to.clip = clipOf(sEl);
      if (onScreen(to)) { media.classList.add('flip'); fly(fr, to, it.poster || it.src, posOf(sEl), 440, finish); return; }
    }
    L.hideT = setTimeout(finish, 340);
  }
  function lbOpen() { return !!(LB && !LB.el.hidden); }
  function onLB(fn) { lbBuild().onChange.push(fn); }

  /* ---------- hero: 3D ring of photos, slow drift, drag with inertia, tap to enlarge ---------- */
  function initRing(root) {
    var ring = root.querySelector('[data-ring]'); if (!ring) return;
    var cards = all(ring, '.rd-card'), n = cards.length; if (!n) return;
    var per = cards.filter(function (c) { return !c.hasAttribute('aria-hidden'); }).length || n, step = (Math.PI * 2) / n, offset = 0, AUTO = reduce ? 0 : 0.00045;
    // depth of the curve: data-k = how far the sides come forward, data-d = how far back the middle sits (in card widths)
    var K = +ring.getAttribute('data-k') || 0.5, DEPTH = +ring.getAttribute('data-d') || 0, ROT = +ring.getAttribute('data-rot') || 0.85, LIM = +ring.getAttribute('data-lim') || 0;
    var vel = 0, drag = false, hover = false, lastX = 0, lastT = 0, tap0 = null;
    var SET = cards.slice(0, per).map(function (c) { var im = c.querySelector('img'); return { src: c.getAttribute('data-full') || (im && im.currentSrc), alt: im ? im.alt : '', cap: c.getAttribute('data-cap') || '' }; });
    // the card width is measured once and again on resize, not every frame (reading it after the writes forced a layout per frame)
    var cardW = 0, ringW = 0, P = 1100, lastOff = null, zs = [];
    function measure() { cardW = cards[0].offsetWidth || 230; ringW = ring.clientWidth; P = parseFloat(getComputedStyle(ring).perspective) || 1100; lastOff = null; }
    addEventListener('resize', measure);
    // The middle of the band follows the circle; past A0 the cards keep going straight along its tangent,
    // forward and out, so they stay fully shown and slide out past the screen edge instead of fading
    // in the middle of the screen. A card is hidden only once its inner edge is outside the ring.
    var A0 = 1.0;
    function layout() {
      if (!cardW) measure();
      if (lastOff === offset) return; lastOff = offset;
      var gap = cardW < 200 ? 14 : 22;
      var R = (cardW + gap) / step, D = DEPTH * cardW, edge = ringW / 2 + 12;
      for (var i = 0; i < n; i++) {
        var a = i * step + offset; a = Math.atan2(Math.sin(a), Math.cos(a));
        var b = Math.abs(a), sg = a < 0 ? -1 : 1, x, z, r, c = cards[i];
        if (b <= A0) { x = Math.sin(b) * R; z = (1 - Math.cos(b)) * R * K - D; r = b; }
        else { var t = (b - A0) * R; x = Math.sin(A0) * R + t * Math.cos(A0); z = (1 - Math.cos(A0)) * R * K - D + t * Math.sin(A0) * K; r = A0; }
        var inner = (x - cardW / 2 * Math.cos(r * ROT)) * P / Math.max(1, P - z);
        var shown = P - z > 80 && inner < edge;
        c.style.transform = 'translate3d(' + (sg * x).toFixed(1) + 'px,0,' + z.toFixed(1) + 'px) rotateY(' + (-sg * r * ROT * 57.3).toFixed(2) + 'deg)';
        c.style.opacity = shown ? 1 : 0;
        var zi = Math.round(1000 - Math.abs(a) * 100);
        if (zs[i] !== zi) { zs[i] = zi; c.style.zIndex = zi; }
      }
    }
    // the lightbox flies back to whichever copy of the photo is on screen
    function srcFn(i) { var best = cards[i]; for (var j = i + per; j < n; j += per) if (+getComputedStyle(cards[j]).opacity > +getComputedStyle(best).opacity) best = cards[j]; return best; }
    ring.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') hover = true; });
    ring.addEventListener('pointerleave', function () { hover = false; });
    ring.addEventListener('pointerdown', function (e) { drag = true; vel = 0; lastX = e.clientX; lastT = performance.now(); tap0 = { x: e.clientX, y: e.clientY }; try { ring.setPointerCapture(e.pointerId); } catch (err) {} });
    ring.addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - lastX, now = performance.now(), d = dx * 0.0022;
      offset += d; vel = d / Math.max(1, (now - lastT) / 16); lastX = e.clientX; lastT = now;
    });
    ring.addEventListener('pointerup', function (e) {
      drag = false;
      if (!tap0) return;
      var moved = Math.abs(e.clientX - tap0.x) + Math.abs(e.clientY - tap0.y); tap0 = null;
      if (moved > 8) return;
      var hit = document.elementsFromPoint(e.clientX, e.clientY).filter(function (el) { return el.classList && el.classList.contains('rd-card') && ring.contains(el); })[0];
      if (!hit) return;
      vel = 0;
      if (hit.getAttribute('data-href')) { location.href = hit.getAttribute('data-href'); return; }
      openLB(SET, cards.indexOf(hit) % per, hit, srcFn);
    });
    ring.addEventListener('pointercancel', function () { drag = false; tap0 = null; });
    layout();
    addFrame(ring, function () {
      if (lbOpen()) return;
      if (!drag) { offset += vel; vel *= 0.94; if (!hover && Math.abs(vel) < 0.0004) offset -= AUTO; }
      layout();
    });
  }

  /* ---------- kitchen rail: slow drift, drag with inertia, seamless loop, tap to enlarge ---------- */
  function initRail(root) {
    var rail = root.querySelector('[data-rail]'); if (!rail) return;
    var track = rail.querySelector('.rail-track'), orig = all(track, 'figure'), RN = orig.length; if (!RN) return;
    for (var c = 0; c < 2; c++) orig.forEach(function (f) {
      var k = f.cloneNode(true); k.setAttribute('aria-hidden', 'true'); k.setAttribute('tabindex', '-1'); k.removeAttribute('role');
      k.removeAttribute('data-shopify-editor-block'); track.appendChild(k);
    });
    var SET = orig.map(function (f) { var im = f.querySelector('img'); return { src: f.getAttribute('data-full') || (im && im.currentSrc), alt: im ? im.alt : '', cap: f.getAttribute('data-cap') || '' }; });
    var bars = all(root, '.rail-prog i'), nEl = root.querySelector('.rail-n');
    var rx = 0, rv = 0, rDrag = null, rHover = false, rFocus = false, rW = 0, lastN = -1, SPEED = reduce ? 0 : 0.42;
    function measure() { var a = track.children[0], b = track.children[RN]; rW = b ? b.getBoundingClientRect().left - a.getBoundingClientRect().left : 0; }
    addEventListener('resize', function () { rW = 0; });
    addFrame(rail, function (dt) {
      if (lbOpen()) return;
      if (!rW) measure();
      if (!rDrag) {
        if (rv) { rx += rv * dt; rv *= Math.pow(0.94, dt); if (Math.abs(rv) < 0.04) rv = 0; }
        else if (!rHover && !rFocus) rx += SPEED * dt;
      }
      if (rW > 0) rx = ((rx % rW) + rW) % rW;
      track.style.transform = 'translate3d(' + (-rx).toFixed(2) + 'px,0,0)';
      var p = rW ? rx / rW : 0;
      if (bars[0]) { bars[0].style.width = 'calc(100% / ' + RN + ')'; bars[0].style.transform = 'translateX(' + (p * RN * 100).toFixed(1) + '%)'; }
      if (bars[1]) { bars[1].style.width = 'calc(100% / ' + RN + ')'; bars[1].style.transform = 'translateX(' + ((p * RN - RN) * 100).toFixed(1) + '%)'; }
      var k = Math.floor(p * RN + 0.5) % RN;
      if (k !== lastN && nEl) { lastN = k; nEl.textContent = ('0' + (k + 1)).slice(-2) + ' / ' + ('0' + RN).slice(-2); }
    });
    function srcFn(i) {
      var best = null, bd = 1e9, mid = innerWidth / 2;
      all(track, 'figure').forEach(function (f) {
        if (+f.getAttribute('data-i') !== i) return;
        var r = f.getBoundingClientRect(), d = Math.abs(r.left + r.width / 2 - mid);
        if (d < bd) { bd = d; best = f; }
      });
      return best && best.querySelector('.ph');
    }
    rail.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') rHover = true; });
    rail.addEventListener('pointerleave', function () { rHover = false; });
    rail.addEventListener('pointerdown', function (e) {
      if (e.pointerType === 'mouse' && e.button !== 0) return;
      rv = 0; rDrag = { x: e.clientX, rx: rx, moved: false, id: e.pointerId, lx: e.clientX, lt: performance.now(), fig: e.target.closest('figure') };
    });
    rail.addEventListener('pointermove', function (e) {
      if (!rDrag || e.pointerId !== rDrag.id) return;
      var dx = e.clientX - rDrag.x;
      if (!rDrag.moved && Math.abs(dx) > 6) { rDrag.moved = true; rail.classList.add('dragging'); try { rail.setPointerCapture(e.pointerId); } catch (err) {} }
      if (rDrag.moved) {
        rx = rDrag.rx - dx;
        var now = performance.now(), dtm = Math.max(1, now - rDrag.lt);
        rv = -(e.clientX - rDrag.lx) / dtm * 16.67; rDrag.lx = e.clientX; rDrag.lt = now;
      }
    });
    function up(e) {
      if (!rDrag) return;
      var d = rDrag; rDrag = null; rail.classList.remove('dragging');
      if (!d.moved) { rv = 0; if (e.type === 'pointerup' && d.fig) openLB(SET, +d.fig.getAttribute('data-i'), rail, srcFn); return; }
      if (performance.now() - d.lt > 90) rv = 0;
      rv = Math.max(-60, Math.min(60, rv));
    }
    rail.addEventListener('pointerup', up);
    rail.addEventListener('pointercancel', up);
    rail.addEventListener('dragstart', function (e) { e.preventDefault(); });
    rail.addEventListener('focusin', function (e) {
      rail.scrollLeft = 0;
      var f = e.target.closest('figure'); if (!f) return;
      var kb = true; try { kb = f.matches(':focus-visible'); } catch (err) {}
      if (!kb) return;
      rFocus = true;
      var rr = rail.getBoundingClientRect(), fr = f.getBoundingClientRect();
      if (fr.left < rr.left + 16 || fr.right > rr.right - 16) rx += fr.left - rr.left - Math.max(16, (rr.width - fr.width) / 2);
    });
    rail.addEventListener('focusout', function () { rFocus = false; });
    rail.addEventListener('scroll', function () { rail.scrollLeft = 0; });
    rail.addEventListener('keydown', function (e) {
      var f = e.target.closest('figure');
      if (f && (e.key === 'Enter' || e.key === ' ')) { e.preventDefault(); openLB(SET, +f.getAttribute('data-i'), f, srcFn); }
    });
  }

  /* ---------- shards: tap to open on phones, tap again to enlarge; click to enlarge on desktop ---------- */
  function initShards(root) {
    var shards = all(root, '.shard'); if (!shards.length) return;
    var SET = shards.map(function (s) { var im = s.querySelector('img'); return { src: s.getAttribute('data-full') || (im && im.currentSrc), alt: im ? im.alt : '', cap: s.getAttribute('data-cap') || '' }; });
    function srcFn(i) { return shards[i]; }
    shards.forEach(function (s, i) {
      s.setAttribute('tabindex', '0'); s.setAttribute('role', 'button');
      s.addEventListener('click', function () {
        if (narrow.matches && !s.classList.contains('open')) { shards.forEach(function (o) { o.classList.remove('open'); }); s.classList.add('open'); return; }
        openLB(SET, i, s, srcFn);
      });
      s.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); openLB(SET, i, s, srcFn); } });
    });
    // after the enlarged photo closes, the shard folds back to its narrow strip
    onLB(function () { if (!lbOpen()) shards.forEach(function (o) { o.classList.remove('open'); }); });
  }

  /* ---------- word-by-word reveal ---------- */
  var reveals = [];
  function initReveal(root) {
    all(root, '.reveal').forEach(function (box) {
      if (box.dataset.split) return; box.dataset.split = '1';
      var list = [];
      all(box, 'p').forEach(function (p) {
        var parts = p.textContent.split(/(\s+)/); p.textContent = '';
        parts.forEach(function (t) {
          if (/^\s+$/.test(t) || t === '') { p.appendChild(document.createTextNode(t)); return; }
          var s = document.createElement('span'); s.className = 'w'; s.textContent = t; p.appendChild(s); list.push(s);
        });
      });
      reveals.push({ box: box, list: list });
    });
    revealScroll();
  }
  var revealRaf = 0;
  function revealScroll() { if (!revealRaf) revealRaf = requestAnimationFrame(function () { revealRaf = 0; revealPaint(); }); }
  function revealPaint() {
    reveals = reveals.filter(function (g) { return g.box.isConnected; });
    reveals.forEach(function (g) {
      if (reduce) { g.list.forEach(function (w) { w.style.setProperty('--o', 1); }); return; }
      var r = g.box.getBoundingClientRect(); if (!r.height) return;
      var start = innerHeight * 0.88, end = innerHeight * 0.38;
      var p = Math.min(1, Math.max(0, (start - r.top) / (start - end + r.height * 0.6)));
      var N = g.list.length, k = p * (N + 4);
      if (r.bottom < 0 || r.top > innerHeight) { if (g.done === p) return; }
      g.done = p;
      g.list.forEach(function (w, i) { var o = (0.22 + 0.78 * Math.min(1, Math.max(0, k - i))).toFixed(2); if (w._o !== o) { w._o = o; w.style.setProperty('--o', o); } });
    });
  }
  onScroll(revealScroll);
  addEventListener('resize', revealScroll);

  /* ---------- sizes photo: five diagonal slices drift apart and close up as the block scrolls into view ---------- */
  function initSlices(root) {
    var box = root.querySelector('[data-slices]'); if (!box) return;
    var slices = all(box, '.slice'), SN = slices.length, SK = 9, cur = -1;
    slices.forEach(function (sl, i) {
      var w = 100 / SN, x0 = i * w, x1 = (i + 1) * w;
      var L0 = i ? x0 + SK : -1, L1 = i ? x0 - SK : -1, R0 = i < SN - 1 ? x1 + SK + .4 : 101, R1 = i < SN - 1 ? x1 - SK + .4 : 101;
      sl.style.setProperty('--cp', 'polygon(' + L0 + '% 0,' + R0 + '% 0,' + R1 + '% 100%,' + L1 + '% 100%)');
    });
    // the cut pieces close up over the whole way from the bottom of the screen to just under the header,
    // so the photo is whole only once it reaches the top (Max, 26.10: before, it joined while still low on the screen)
    var headH = 0;
    function readHead() { headH = (parseFloat(getComputedStyle(document.body).getPropertyValue('--header-group-height')) || 100) + 16; }
    addEventListener('resize', readHead);
    function target() {
      if (!headH) readHead();
      var r = box.getBoundingClientRect(), vh = innerHeight, top = headH;
      return Math.min(1, Math.max(0, (vh - r.top) / Math.max(1, vh - top)));
    }
    function apply(p) {
      var f = Math.pow(1 - p, 1.5);
      slices.forEach(function (sl, i) { var k = i - (SN - 1) / 2; sl.style.transform = 'translate3d(' + (k * 16 * f).toFixed(1) + 'px,' + ((i % 2 ? 1 : -1) * 64 * f).toFixed(1) + 'px,0)'; });
    }
    if (reduce) { apply(1); return; }
    addFrame(box, function () {
      var t = target();
      if (cur < 0) { cur = t; apply(cur); return; }
      var d = t - cur; if (d === 0) return;
      cur = Math.abs(d) < 0.0006 ? t : cur + d * 0.1; apply(cur);
    });
  }

  /* ---------- "the difference": hand-drawn arrows from each label to its pulsing point ---------- */
  var vsFigs = [];
  function vsArrows() {
    vsFigs = vsFigs.filter(function (f) { return f.isConnected; });
    vsFigs.forEach(function (fig) {
      var svg = fig.querySelector('.vs-arrows'), fr = fig.getBoundingClientRect();
      if (!svg || !fr.width) return;
      svg.setAttribute('viewBox', '0 0 ' + fr.width.toFixed(1) + ' ' + fr.height.toFixed(1));
      var paths = [];
      all(fig, '.hl').forEach(function (l, k) {
        var hs = fig.querySelector('[data-hs="' + l.getAttribute('data-for') + '"]'); if (!hs) return;
        var lr = l.getBoundingClientRect(), hr = hs.getBoundingClientRect();
        var hx = hr.left + hr.width / 2 - fr.left, hy = hr.top + hr.height / 2 - fr.top;
        var cx = (lr.left + lr.right) / 2 - fr.left, cy = (lr.top + lr.bottom) / 2 - fr.top;
        var dx = hx - cx, dy = hy - cy, hw = lr.width / 2, hh = lr.height / 2;
        var t = Math.min(dx ? hw / Math.abs(dx) : 1e9, dy ? hh / Math.abs(dy) : 1e9), dl = Math.hypot(dx, dy) || 1;
        var sx = cx + dx * t + dx / dl * 7, sy = cy + dy * t + dy / dl * 7;
        var vx = hx - sx, vy = hy - sy, len = Math.hypot(vx, vy) || 1, ux = vx / len, uy = vy / len;
        var ex = hx - ux * 13, ey = hy - uy * 13, bow = (k % 2 ? 1 : -1) * Math.min(40, len * 0.24);
        var qx = (sx + ex) / 2 - uy * bow, qy = (sy + ey) / 2 + ux * bow;
        var tx = ex - qx, ty = ey - qy, tl = Math.hypot(tx, ty) || 1; tx /= tl; ty /= tl;
        var A = 0.48, H = 9;
        var h1x = ex - H * (tx * Math.cos(A) - ty * Math.sin(A)), h1y = ey - H * (ty * Math.cos(A) + tx * Math.sin(A));
        var h2x = ex - H * (tx * Math.cos(A) + ty * Math.sin(A)), h2y = ey - H * (ty * Math.cos(A) - tx * Math.sin(A));
        function f(v) { return v.toFixed(1); }
        paths.push('<path style="--d:' + (0.15 + k * 0.35).toFixed(2) + 's" d="M' + f(sx) + ' ' + f(sy) + ' Q' + f(qx) + ' ' + f(qy) + ' ' + f(ex) + ' ' + f(ey) + ' M' + f(h1x) + ' ' + f(h1y) + ' L' + f(ex) + ' ' + f(ey) + ' L' + f(h2x) + ' ' + f(h2y) + '"/>');
      });
      svg.innerHTML = paths.join('');
      var drawn = reduce || fig.dataset.drawn === '1';
      all(svg, 'path').forEach(function (p) {
        var Lg = Math.ceil(p.getTotalLength()) + 2;
        p.style.transition = 'none'; p.style.strokeDasharray = Lg; p.style.strokeDashoffset = drawn ? 0 : Lg;
        p.getBoundingClientRect(); p.style.transition = '';
      });
    });
  }
  var vsIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (es) {
    es.forEach(function (e) { if (!e.isIntersecting || e.target.dataset.drawn === '1') return; e.target.dataset.drawn = '1'; all(e.target, '.vs-arrows path').forEach(function (p) { p.style.strokeDashoffset = 0; }); });
  }, { threshold: 0.45 }) : null;
  function initDiff(root) {
    all(root, '.vs').forEach(function (fig) {
      vsFigs.push(fig);
      if (vsIO) vsIO.observe(fig); else fig.dataset.drawn = '1';
      var im = fig.querySelector('img'); if (im && !im.complete) im.addEventListener('load', vsArrows);
    });
    vsArrows();
  }
  addEventListener('resize', vsArrows);
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(vsArrows);

  /* ---------- videos: 3D coverflow of 9:16 cards ----------
     Only the front card and its two neighbours carry a src; only the front card plays, and only while on screen. */
  var cfs = [], cfSound = false; // one switch for every carousel: once sound is on, the next clip plays with sound too
  function initVideos(root) {
    all(root, '[data-cf]').forEach(function (box) {
      var stage = box.querySelector('.cf-stage'), cards = all(stage, '.cf-card'), N = cards.length; if (!N) return;
      var nEl = box.querySelector('.cf-n'), vids = cards.map(function (c) { return c.querySelector('video'); });
      var CL = cards.map(function (c) { return { src: c.getAttribute('data-src'), poster: c.getAttribute('data-poster'), snd: c.getAttribute('data-snd') === '1', cap: c.getAttribute('data-cap') || '' }; });
      var act = 0, inView = false, sw = null, moved = false, held = false, raf = 0, scrubbing = null;
      function attach(v, c, eager) { if (v.getAttribute('src') !== c.src) { v.preload = eager ? 'auto' : 'metadata'; v.src = c.src; } else if (eager) v.preload = 'auto'; }
      function detach(v) { if (v.hasAttribute('src')) { v.pause(); v.removeAttribute('src'); v.preload = 'none'; try { v.load(); } catch (e) {} } }
      function visible() { return inView && !document.hidden && !lbOpen(); }
      function dist(i) { var d = i - act; if (d > N / 2) d -= N; if (d < -N / 2) d += N; return d; }
      function paintSnd() { cards.forEach(function (c) { var b = c.querySelector('.cf-snd'); if (!b) return; b.classList.toggle('on', cfSound); b.setAttribute('aria-pressed', cfSound); b.setAttribute('aria-label', cfSound ? 'Turn sound off' : 'Turn sound on'); }); }
      function progress() {
        raf = 0;
        var v = vids[act], c = cards[act];
        if (v.duration && !scrubbing) c.querySelector('.cf-scrub').style.setProperty('--p', (v.currentTime / v.duration).toFixed(4));
        if (visible()) raf = requestAnimationFrame(progress);
      }
      function sync() {
        var on = visible();
        vids.forEach(function (v, i) {
          var a = Math.abs(dist(i));
          if (a > 1) { detach(v); return; }
          if (on || v.hasAttribute('src')) attach(v, CL[i], a === 0);
          v.muted = !(a === 0 && cfSound && CL[i].snd);
          cards[i].classList.toggle('held', a === 0 && held);
          if (a === 0 && on && !reduce && !held) { var p = v.play(); if (p && p.catch) p.catch(function () { v.muted = true; v.play().catch(function () {}); }); }
          else if (!v.paused) v.pause();
        });
        if (on && !raf) raf = requestAnimationFrame(progress);
      }
      function lay() {
        var w = cards[0].offsetWidth || 260;
        cards.forEach(function (c, i) {
          var d = dist(i), a = Math.abs(d);
          c.style.transform = 'translateX(' + (d * w * 0.56).toFixed(1) + 'px) translateZ(' + (-a * 170) + 'px) rotateY(' + (-d * 32) + 'deg)';
          c.style.opacity = a > 2 ? 0 : a === 2 ? .5 : 1;
          c.style.filter = a ? 'brightness(' + (a === 1 ? .62 : .42) + ')' : 'none';
          c.style.zIndex = 10 - a;
          c.style.pointerEvents = a > 2 ? 'none' : '';
          c.classList.toggle('on', d === 0);
          c.setAttribute('aria-hidden', d === 0 ? 'false' : 'true');
        });
        if (nEl) nEl.textContent = (act + 1) + ' / ' + N;
        sync();
      }
      function go(i) { act = (i + N) % N; held = false; lay(); }
      stage.addEventListener('click', function (e) {
        var b = e.target.closest('.cf-snd'); if (!b) return;
        e.stopPropagation();
        cfSound = !cfSound; cfs.forEach(function (o) { o.paintSnd(); });
        var v = vids[act]; attach(v, CL[act], true); v.muted = !cfSound;
        if (cfSound) { try { v.currentTime = 0; } catch (err) {} held = false; cards[act].classList.remove('held'); var p = v.play(); if (p && p.catch) p.catch(function () {}); }
        cfs.forEach(function (o) { o.sync(); });
      }, true);
      function seekTo(e) {
        var bar = scrubbing.bar, r = bar.getBoundingClientRect(), f = Math.max(0, Math.min(1, (e.clientX - r.left - 14) / Math.max(1, r.width - 28)));
        bar.style.setProperty('--p', f.toFixed(4)); bar.setAttribute('aria-valuenow', Math.round(f * 100));
        var v = vids[act]; if (v.duration) try { v.currentTime = f * v.duration; } catch (err) {}
      }
      stage.addEventListener('pointerdown', function (e) {
        var bar = e.target.closest('.cf-scrub'); if (!bar) return;
        e.stopPropagation(); e.preventDefault();
        attach(vids[act], CL[act], true);
        scrubbing = { bar: bar, id: e.pointerId }; bar.classList.add('drag');
        try { bar.setPointerCapture(e.pointerId); } catch (err) {}
        seekTo(e);
      }, true);
      stage.addEventListener('pointermove', function (e) { if (scrubbing && e.pointerId === scrubbing.id) { e.stopPropagation(); seekTo(e); } }, true);
      function scrubEnd(e) { if (!scrubbing) return; e.stopPropagation(); scrubbing.bar.classList.remove('drag'); scrubbing = null; moved = true; }
      stage.addEventListener('pointerup', scrubEnd, true);
      stage.addEventListener('pointercancel', scrubEnd, true);
      box.querySelector('[data-cf-prev]').addEventListener('click', function () { go(act - 1); });
      box.querySelector('[data-cf-next]').addEventListener('click', function () { go(act + 1); });
      box.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight') { e.preventDefault(); go(act + 1); }
        else if (e.key === 'ArrowLeft') { e.preventDefault(); go(act - 1); }
      });
      stage.addEventListener('pointerdown', function (e) { sw = { x: e.clientX, y: e.clientY, id: e.pointerId }; moved = false; });
      stage.addEventListener('pointermove', function (e) {
        if (!sw) return;
        if (!moved && Math.abs(e.clientX - sw.x) > 8) { moved = true; stage.classList.add('dragging'); try { stage.setPointerCapture(sw.id); } catch (err) {} }
      });
      stage.addEventListener('pointerup', function (e) {
        if (!sw) return; var dx = e.clientX - sw.x; sw = null; stage.classList.remove('dragging');
        if (moved && Math.abs(dx) > 36) go(act + (dx < 0 ? 1 : -1));
      });
      stage.addEventListener('pointercancel', function () { sw = null; stage.classList.remove('dragging'); });
      stage.addEventListener('click', function (e) {
        if (moved) { moved = false; return; }
        var c = e.target.closest('.cf-card'); if (!c) return;
        var i = cards.indexOf(c);
        if (i !== act) { go(i); return; }
        var v = vids[i]; attach(v, CL[i], true);
        if (v.paused) { held = false; var p = v.play(); if (p && p.catch) p.catch(function () {}); } else { held = true; v.pause(); }
        c.classList.toggle('held', held);
      });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { inView = es[0].isIntersecting; sync(); }, { threshold: 0.35 }).observe(stage);
      else inView = true;
      addEventListener('resize', lay);
      document.addEventListener('visibilitychange', sync);
      var api = { sync: sync, paintSnd: paintSnd };
      cfs.push(api);
      onLB(sync);
      lay(); paintSnd();
    });
  }

  /* ---------- home engraving preview: same fonts, field and limits as the product page ----------
     "Engrave my set" saves the text, font, size and alignment as the product page's own draft
     (localStorage, the format wh-engraving.js restores), then opens the product. */
  var MAX = 25, MAXLINES = 2, BOXH = 0.339, SCALE_MIN = 0.45;
  var BAD = /[\u0000-\u001F\u007F-\u009F­​⁠﻿︀-️]/g;
  var FONT_TAIL = '"Noto Sans Symbols 2", Jost, system-ui, serif';
  var FONTS = [
    { id: 'classic', fam: 'Cormorant Garamond', style: 'italic', weight: 600, k: 1, wk: 1 },
    { id: 'serif', fam: 'Playfair Display', style: 'normal', weight: 500, k: 0.9, wk: 1 },
    { id: 'modern', fam: 'Montserrat', style: 'normal', weight: 500, k: 0.9, wk: 1 },
    { id: 'script', fam: 'Dancing Script', style: 'normal', weight: 700, k: 0.9, wk: 0.96 }
  ];
  function fontOf(s) { for (var i = 0; i < FONTS.length; i++) if (FONTS[i].id === (s && s.font)) return FONTS[i]; return FONTS[0]; }
  function fontCss(F) { return '"' + F.fam + '", ' + FONT_TAIL; }
  function fontLoadSpec(F) { return F.style + ' ' + F.weight + ' 40px "' + F.fam + '"'; }
  function frac(v) { return SCALE_MIN + (Math.max(0, Math.min(100, Number(v) || 0)) / 100) * (1 - SCALE_MIN); }
  function clean(v) { return Array.from(String(v || '').replace(/[\r\n\t]+/g, ' ').replace(BAD, '')).slice(0, MAX).join(''); }
  function clen(t) { return Array.from(t || '').length; }
  function wrapText(v) {
    var src = String(v || '').replace(/\r/g, '').replace(/\t/g, ' ').split('\n'), outL = [], cut = false;
    src.forEach(function (line) {
      var ch = Array.from(line.replace(BAD, ''));
      while (ch.length > MAX) {
        var head = ch.slice(0, MAX + 1), sp = head.lastIndexOf(' ');
        if (sp > 0) { outL.push(ch.slice(0, sp).join('')); ch = ch.slice(sp + 1); }
        else { outL.push(ch.slice(0, MAX).join('')); ch = ch.slice(MAX); }
      }
      outL.push(ch.join(''));
    });
    if (outL.length > MAXLINES) { cut = outL.slice(MAXLINES).join('').trim() !== ''; outL = outL.slice(0, MAXLINES); }
    return { lines: outL, cut: cut };
  }
  var AL_ICON = { left: '<path d="M1 2h14M1 6h9M1 10h12"/>', center: '<path d="M1 2h14M3.5 6h9M2 10h12"/>', right: '<path d="M1 2h14M6 6h9M3 10h12"/>' };
  function initEngrave(root) {
    var box = root.querySelector('[data-eg]'); if (!box) return;
    var T = {}; try { T = JSON.parse((root.querySelector('[data-eg-i18n]') || {}).textContent || '{}'); } catch (e) {}
    function t(k, d) { return T[k] || d; }
    var IDEAS = t('ideas', "For Mom, with love||center;Sarah's kitchen||center;The Millers,|est. 2026|right").split(';').map(function (row) { var p = row.split('|'); return [p[0] || '', p[1] || '', p[2] || 'center']; });
    var NAMES = { classic: t('font_classic', 'Classic'), serif: t('font_serif', 'Serif'), modern: t('font_modern', 'Modern'), script: t('font_script', 'Script') };
    var AL_NAME = { left: t('align_left', 'Align left'), center: t('align_center', 'Center'), right: t('align_right', 'Align right') };
    var ta = box.querySelector('textarea'), pv = box.querySelector('[data-eg-pv]'), board = pv.parentNode, e1 = pv.children[0], e2 = pv.children[1];
    var cnt = box.querySelector('[data-eg-cnt]'), hint = box.querySelector('[data-eg-hint]');
    var st = { l1: '', l2: '', hasL2: false, v1: 100, al: 'center', font: 'classic', eg: false, fo: true };
    var sizeBox = box.querySelector('[data-eg-size]'), sid = sizeBox.getAttribute('data-eg-size');
    sizeBox.className = 'eg-size';
    sizeBox.innerHTML = '<label class="lbl" for="' + sid + '">' + esc(t('text_size', 'Size')) + '</label><div class="eg-sl"><button type="button" data-step="-8" aria-label="' + esc(t('smaller', 'Smaller')) + '">&minus;</button><input type="range" id="' + sid + '" min="0" max="100" step="1" value="100"><button type="button" data-step="8" aria-label="' + esc(t('bigger', 'Bigger')) + '">+</button></div><span class="eg-pct" data-eg-pct aria-live="polite">100%</span>';
    var range = sizeBox.querySelector('input'), pct = sizeBox.querySelector('[data-eg-pct]');
    var alBox = box.querySelector('[data-eg-align]');
    alBox.className = 'eg-al'; alBox.setAttribute('role', 'group');
    alBox.innerHTML = '<span class="lbl">' + esc(t('align', 'Align')) + '</span>' + ['left', 'center', 'right'].map(function (a) {
      return '<button type="button" data-al="' + a + '" aria-label="' + esc(AL_NAME[a]) + '" aria-pressed="false"><svg viewBox="0 0 16 12" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round">' + AL_ICON[a] + '</svg></button>';
    }).join('');
    var foBox = box.querySelector('[data-eg-fonts]');
    foBox.innerHTML = '<button type="button" class="eg-tog" data-tog="fo" aria-expanded="true"><span>' + esc(t('font', 'Choose your font')) + '</span><span aria-hidden="true">&minus;</span></button><div class="eg-fo" data-row="fo">' +
      FONTS.map(function (F) { return '<button type="button" data-font="' + F.id + '" aria-pressed="false"><span class="s" style="font-family:' + esc(fontCss(F)) + ';font-style:' + F.style + ';font-weight:' + F.weight + '">Aa</span><span class="n">' + esc(NAMES[F.id]) + '</span></button>'; }).join('') + '</div>';
    var idBox = box.querySelector('[data-eg-ideas]');
    idBox.innerHTML = '<button type="button" class="eg-tog" data-tog="eg" aria-expanded="false"><span>' + esc(t('idea', 'Need an idea?')) + '</span><span aria-hidden="true">+</span></button><div class="eg-ideas" data-row="eg" hidden>' +
      IDEAS.map(function (p, i) { return '<button type="button" data-idea="' + i + '">' + esc(p[0] + (p[1] ? ' ' + p[1] : '')) + '</button>'; }).join('') + '</div>';
    function areaText() { return st.l1 + (st.hasL2 ? '\n' + st.l2 : ''); }
    function syncControls() {
      range.value = st.v1;
      all(alBox, '[data-al]').forEach(function (b) { var on = b.getAttribute('data-al') === st.al; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
      all(foBox, '[data-font]').forEach(function (b) { var on = b.getAttribute('data-font') === fontOf(st).id; b.classList.toggle('on', on); b.setAttribute('aria-pressed', on); });
    }
    function fit() {
      var bw = pv.clientWidth, bh = board.clientHeight;
      if (!bw || !bh) return;
      var F = fontOf(st), wk = F.wk, boxW = bw * wk, boxH = bh * BOXH, two = !!(st.hasL2 && st.l2), maxB = boxH * (two ? 0.46 : 0.80) * F.k;
      pv.style.textAlign = st.al || 'center';
      function textW(el) {
        if (wk < 1) { try { var r = document.createRange(); r.selectNodeContents(el); var rw = r.getBoundingClientRect().width; if (rw > 0) return rw; } catch (err) {} return el.scrollWidth * wk; }
        return el.scrollWidth;
      }
      function shrinkW(el, size) {
        el.style.fontSize = size.toFixed(2) + 'px';
        var w = textW(el);
        if (w > boxW && w > 0) { size = Math.max(4, size * (boxW / w)); el.style.fontSize = size.toFixed(2) + 'px'; }
        var g = 0; while (textW(el) > boxW && size > 4 && g < 20) { size *= 0.97; el.style.fontSize = size.toFixed(2) + 'px'; g++; }
        return size;
      }
      var m1 = shrinkW(e1, maxB), m2 = 0;
      e2.style.display = two ? 'block' : 'none';
      if (two) m2 = shrinkW(e2, maxB);
      var fMax = two ? Math.min(m1, m2) : m1, totalMax = fMax * 1.15 * (two ? 2 : 1);
      if (totalMax > boxH) fMax *= boxH / totalMax;
      var f = fMax * frac(st.v1);
      e1.style.fontSize = f.toFixed(2) + 'px'; if (two) e2.style.fontSize = f.toFixed(2) + 'px';
      pct.textContent = Math.round(Math.max(0, Math.min(100, st.v1))) + '%';
    }
    function paint() {
      fitRows(ta);
      var n1 = clen(st.l1), n2 = clen(st.l2);
      cnt.textContent = st.hasL2 ? n1 + ' / ' + MAX + '  ·  ' + n2 + ' / ' + MAX : n1 + ' / ' + MAX;
      cnt.classList.toggle('max', n1 >= MAX || n2 >= MAX);
      e1.textContent = st.l1.trim() ? st.l1 : t('text_here', 'Your text here');
      e1.style.opacity = st.l1.trim() ? '1' : '.35';
      e2.textContent = st.hasL2 ? st.l2 : '';
      var F = fontOf(st);
      [e1, e2].forEach(function (p) { p.style.fontFamily = fontCss(F); p.style.fontStyle = F.style; p.style.fontWeight = F.weight; });
      fit();
    }
    function fromArea() {
      var before = ta.value, pos = ta.selectionStart, atEnd = pos === before.length;
      var w = wrapText(before), after = w.lines.join('\n');
      if (after !== before) { ta.value = after; var np = atEnd ? after.length : Math.min(pos, after.length); try { ta.setSelectionRange(np, np); } catch (err) {} }
      hint.textContent = w.cut ? t('hint_lines', 'Up to {lines} lines, {max} characters each.').replace('{lines}', MAXLINES).replace('{max}', MAX) : '';
      st.l1 = w.lines[0] || ''; st.hasL2 = w.lines.length > 1; st.l2 = st.hasL2 ? w.lines[1] : '';
    }
    function refit() { if (document.fonts && document.fonts.load) document.fonts.load(fontLoadSpec(fontOf(st)), 'Aa' + st.l1 + st.l2).then(fit).catch(function () {}); }
    ta.addEventListener('input', function () { fromArea(); paint(); });
    ta.addEventListener('keydown', function (e) { if (e.key === 'Enter' && ta.value.split('\n').length >= MAXLINES) e.preventDefault(); });
    range.addEventListener('input', function () { st.v1 = Number(range.value); fit(); });
    box.addEventListener('click', function (e) {
      var b = e.target.closest('button'); if (!b || !box.contains(b)) return;
      if (b.hasAttribute('data-step')) { st.v1 = Math.max(0, Math.min(100, st.v1 + Number(b.getAttribute('data-step')))); range.value = st.v1; fit(); return; }
      if (b.hasAttribute('data-al')) { st.al = b.getAttribute('data-al'); syncControls(); fit(); return; }
      if (b.hasAttribute('data-font')) { st.font = b.getAttribute('data-font'); syncControls(); paint(); refit(); return; }
      if (b.hasAttribute('data-tog')) {
        var k = b.getAttribute('data-tog'), row = box.querySelector('[data-row="' + k + '"]');
        st[k] = !st[k]; row.hidden = !st[k]; b.setAttribute('aria-expanded', st[k]); b.lastElementChild.innerHTML = st[k] ? '&minus;' : '+';
        return;
      }
      if (b.hasAttribute('data-idea')) {
        var p = IDEAS[+b.getAttribute('data-idea')];
        st.l1 = clean(p[0]); st.hasL2 = !!p[1]; st.l2 = p[1] ? clean(p[1]) : ''; st.al = p[2] || 'center'; st.v1 = 100;
        ta.value = areaText(); hint.textContent = ''; syncControls(); paint(); refit();
      }
    });
    // the button carries everything over: the product page reads it as its own saved draft
    var go = box.querySelector('[data-eg-go]');
    if (go) go.addEventListener('click', function () {
      if (!st.l1.trim()) return;
      var s = { mode: 'text', l1: st.l1, l2: st.hasL2 ? st.l2 : '', v1: st.v1, v2: st.v1, hasL2: st.hasL2, eg: false, al: st.al, font: st.font, fo: true };
      try { localStorage.setItem('wh-eng2-' + box.getAttribute('data-key'), JSON.stringify({ t: Date.now(), on: true, diff: false, ok: false, qty: 1, st: [s] })); } catch (e) {}
    });
    var img = board.querySelector('img'); if (img) img.addEventListener('load', fit);
    fromArea(); syncControls(); paint();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
    addEventListener('resize', fit);
  }

  /* ---------- reviews: active card centred, neighbours peek in; endless loop from three cards; drag with inertia ---------- */
  function initDeck(root) {
    all(root, '[data-deck]').forEach(function (deck) {
      var view = deck.querySelector('.car-view'), track = deck.querySelector('.car-track'), cards = all(track, '.rcard'), nEl = deck.querySelector('.deck-n');
      var bPrev = deck.querySelector('[data-d="-1"]'), bNext = deck.querySelector('[data-d="1"]');
      var idx = 0, pos = 0, drag = null, swiped = false, cw = 0, step = 0, W = 0;
      if (!cards.length) return;
      deck.tabIndex = 0; deck.setAttribute('role', 'region'); deck.setAttribute('aria-roledescription', 'carousel');
      var bar1 = deck.querySelector('.deck-prog i'), bar2 = bar1 && bar1.nextElementSibling, bCur = null, bT = 0, bRaf = 0;
      deck.querySelector('.deck-prog').style.setProperty('--n', cards.length);
      function looped() { return cards.length >= 3; }
      function mod(i) { var n = cards.length; return ((i % n) + n) % n; }
      function wrapD(d) { if (!looped()) return d; var n = cards.length; d = mod(d); return d >= n / 2 ? d - n : d; }
      function measure() { W = view.clientWidth; cw = cards[0].offsetWidth; step = cw ? cw + (parseFloat(getComputedStyle(track).columnGap) || 0) : 0; }
      function barDraw() { var n = cards.length, q = ((bCur % n) + n) % n; if (bar1) bar1.style.transform = 'translateX(' + (q * 100).toFixed(1) + '%)'; if (bar2) bar2.style.transform = 'translateX(' + ((q - n) * 100).toFixed(1) + '%)'; }
      function barStep() { bRaf = 0; var d = bT - bCur; bCur = Math.abs(d) < 0.002 ? bT : bCur + d * 0.2; barDraw(); if (bCur !== bT) bRaf = requestAnimationFrame(barStep); }
      function barTo(p) { bT = p; if (bCur === null || reduce || drag || !deck.classList.contains('anim')) { cancelAnimationFrame(bRaf); bRaf = 0; bCur = p; barDraw(); return; } if (!bRaf) bRaf = requestAnimationFrame(barStep); }
      function place(p) {
        pos = p; if (!step) measure(); if (!step) return;
        track.style.transform = 'none';
        cards.forEach(function (c, i) {
          var d = wrapD(i - p), ad = Math.abs(d), a = Math.min(1, ad), sg = d < 0 ? -1 : 1;
          var x = W / 2 - cw / 2 - i * step + d * step - sg * a * cw * 0.05;
          var jump = c._d != null && Math.abs(d - c._d) > 1.5; c._d = d;
          if (jump) c.style.transition = 'none';
          c.style.transform = 'translate3d(' + x.toFixed(1) + 'px,0,0) scale(' + (1 - 0.1 * a).toFixed(4) + ')';
          c.style.opacity = Math.max(0, 1 - 0.36 * a - (ad > 1 ? 0.64 * Math.min(1, (ad - 1) / 1.1) : 0)).toFixed(3);
          c.style.setProperty('--a', a.toFixed(3));
          if (jump) { void c.offsetWidth; c.style.transition = ''; }
        });
        barTo(p);
      }
      function paint() {
        var on = mod(idx);
        cards.forEach(function (c, i) { c.classList.toggle('side', i !== on); c.setAttribute('aria-hidden', i === on ? 'false' : 'true'); });
        if (nEl) nEl.textContent = (on + 1) + ' / ' + cards.length;
        bPrev.disabled = cards.length < 2 || (!looped() && idx <= 0);
        bNext.disabled = cards.length < 2 || (!looped() && idx >= cards.length - 1);
      }
      function go(i, animate) { idx = looped() ? i : Math.max(0, Math.min(cards.length - 1, i)); deck.classList.toggle('anim', animate !== false && !reduce); place(idx); paint(); }
      deck.querySelector('.deck-ctl').addEventListener('click', function (e) { var b = e.target.closest('[data-d]'); if (b && !b.disabled) go(idx + (+b.getAttribute('data-d'))); });
      track.addEventListener('click', function (e) { if (swiped) return; var c = e.target.closest('.rcard'); if (c && c.classList.contains('side')) go(idx + Math.round(wrapD(cards.indexOf(c) - idx))); });
      view.addEventListener('pointerdown', function (e) {
        if (cards.length < 2 || (e.pointerType === 'mouse' && e.button !== 0) || e.target.closest('.rc-media')) return;
        drag = { x: e.clientX, y: e.clientY, p0: pos, moved: false, id: e.pointerId, lx: e.clientX, lt: performance.now(), v: 0 };
      });
      view.addEventListener('pointermove', function (e) {
        if (!drag || e.pointerId !== drag.id) return;
        var dx = e.clientX - drag.x, dy = e.clientY - drag.y;
        if (!drag.moved) {
          if (Math.abs(dy) > 10 && Math.abs(dy) > Math.abs(dx)) { drag = null; return; }
          if (Math.abs(dx) < 6) return;
          drag.moved = true; view.classList.add('dragging'); deck.classList.remove('anim');
          try { view.setPointerCapture(e.pointerId); } catch (err) {}
          if (!step) measure();
        }
        if (!step) return;
        var p = drag.p0 - dx / step, max = cards.length - 1;
        if (!looped()) { if (p < 0) p *= 0.3; else if (p > max) p = max + (p - max) * 0.3; }
        var now = performance.now(), dt = Math.max(1, now - drag.lt);
        drag.v = drag.v * 0.5 + ((e.clientX - drag.lx) / dt) * 0.5; drag.lx = e.clientX; drag.lt = now;
        place(p);
      });
      function up() {
        if (!drag) return; var d = drag; drag = null; view.classList.remove('dragging');
        if (!d.moved) return;
        swiped = true; setTimeout(function () { swiped = false; }, 0);
        var v = performance.now() - d.lt > 100 ? 0 : d.v, tgt = Math.round(pos - (v * 240) / step);
        if (tgt === idx && Math.abs(pos - idx) > 0.12) tgt = idx + (pos > idx ? 1 : -1);
        go(tgt, true);
      }
      view.addEventListener('pointerup', up); view.addEventListener('pointercancel', up);
      view.addEventListener('dragstart', function (e) { e.preventDefault(); });
      deck.addEventListener('keydown', function (e) { if (e.key === 'ArrowRight') { e.preventDefault(); go(idx + 1); } else if (e.key === 'ArrowLeft') { e.preventDefault(); go(idx - 1); } });
      addEventListener('resize', function () { deck.classList.remove('anim'); step = 0; measure(); place(idx); });
      go(0, false);
      // a card's own photos and videos: arrows, dots, tap to open them in the viewer
      deck.addEventListener('click', function (e) {
        var nav = e.target.closest('.rc-nav');
        if (nav) { e.stopPropagation(); var tr = nav.closest('.rc-media').querySelector('.rc-mtrack'), w = tr.clientWidth, k = Math.round(tr.scrollLeft / w), n = tr.children.length;
          k = (k + (nav.classList.contains('rc-next') ? 1 : -1) + n) % n; tr.scrollTo({ left: k * w, behavior: reduce ? 'auto' : 'smooth' }); return; }
        var m = e.target.closest('.rc-m'); if (!m || m.closest('.side')) return;
        e.stopPropagation();
        var trk = m.parentNode, items = all(trk, '.rc-m');
        var set = items.map(function (b) { return b.getAttribute('data-video') ? { video: true, src: b.getAttribute('data-video'), poster: b.getAttribute('data-poster'), ar: 9 / 16, cap: b.getAttribute('data-cap') } : { src: b.getAttribute('data-full'), cap: b.getAttribute('data-cap') }; });
        openLB(set, items.indexOf(m), m, function (i) { var b = items[i]; if (b && Math.abs(b.offsetLeft - trk.scrollLeft) > 2) trk.scrollLeft = b.offsetLeft; return b; });
      }, true);
      all(deck, '.rc-mtrack').forEach(function (tr) {
        tr.addEventListener('scroll', function () { var k = Math.round(tr.scrollLeft / Math.max(1, tr.clientWidth)); all(tr.parentNode, '.rc-dots i').forEach(function (d, j) { d.classList.toggle('on', j === k); }); }, { passive: true });
      });
    });
  }

  /* ---------- header: slide-out menu, smooth jumps to blocks on the home page, underline follows the block ---------- */
  function initHeader(root) {
    var head = root.querySelector('nav.top'); if (!head) return;
    var drawer = root.querySelector('.drawer'), btn = root.querySelector('[data-wh-menu]');
    function setMenu(on) {
      if (!drawer) return;
      drawer.hidden = !on; if (btn) btn.setAttribute('aria-expanded', on);
      document.documentElement.classList.toggle('wh-rd-menu-open', on);
      if (on) { var x = drawer.querySelector('[data-wh-menu-close]'); if (x) x.focus(); }
    }
    if (btn) btn.addEventListener('click', function () { setMenu(true); });
    if (drawer) drawer.addEventListener('click', function (e) {
      if (e.target === drawer || e.target.closest('[data-wh-menu-close]') || e.target.closest('.pane a')) setMenu(false);
    });
    document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && drawer && !drawer.hidden) { setMenu(false); if (btn) btn.focus(); } });
    // Horizon's sticky product gallery reads these
    function heights() { var g = document.getElementById('header-group'); if (!g) return; var h = g.offsetHeight; document.body.style.setProperty('--header-height', h + 'px'); document.body.style.setProperty('--header-group-height', h + 'px'); }
    heights(); addEventListener('resize', heights);
    // a link to a block on this same page glides there instead of reloading
    document.addEventListener('click', function (e) {
      var a = e.target.closest('a[href*="#"]'); if (!a || e.metaKey || e.ctrlKey) return;
      var u; try { u = new URL(a.href, location.href); } catch (err) { return; }
      if (u.pathname.replace(/\/$/, '') !== location.pathname.replace(/\/$/, '') || !u.hash) return;
      var el = document.getElementById(decodeURIComponent(u.hash.slice(1))); if (!el) return;
      e.preventDefault(); setMenu(false);
      el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      if (history.replaceState) history.replaceState(null, '', u.hash);
    });
    // on the home page the underline moves to "Why solid wood" / "FAQ" as you reach them
    var links = all(head, '.links a'), spy = links.filter(function (a) { return a.hash && document.getElementById(a.hash.slice(1)); });
    if (!spy.length) return;
    var homeLink = links.filter(function (a) { return !a.hash && a.classList.contains('on'); })[0];
    function paint() {
      var cur = homeLink, y = innerHeight * 0.4;
      spy.forEach(function (a) { var r = document.getElementById(a.hash.slice(1)).getBoundingClientRect(); if (r.top < y && r.bottom > y) cur = a; });
      links.forEach(function (a) { a.classList.toggle('on', a === cur); });
    }
    onScroll(paint); paint();
  }

  /* ---------- product page: gallery, clip strip, option-linked photo, phone bar ---------- */
  function initProduct(root) {
    var track = root.querySelector('.gtrack'); if (!track) return;
    var thumbsBox = root.querySelector('.thumbs'), slides = all(track, '.gslide'), thumbs = all(thumbsBox, 'button');
    var N = slides.length, gi = 0, lock = -1, lockT = 0, cnt = root.querySelector('.gcount'), bar = root.querySelector('.gprog i');
    var SET = slides.map(function (f) { return { src: f.getAttribute('data-full') || '', cap: f.getAttribute('data-cap') || '', alt: f.getAttribute('data-cap') || '' }; });
    function upd(i) {
      gi = i;
      if (cnt) cnt.textContent = (gi + 1) + ' / ' + N;
      if (bar) bar.style.transform = 'translateX(' + (gi * 100) + '%)';
      slides.forEach(function (sl, j) { sl.classList.toggle('on', j === gi); });
      thumbs.forEach(function (b, j) { b.classList.toggle('on', j === gi); b.setAttribute('aria-current', j === gi ? 'true' : 'false'); });
      var b = thumbs[gi];
      if (b && thumbsBox.clientWidth) {
        if (thumbsBox.scrollWidth > thumbsBox.clientWidth + 2) thumbsBox.scrollTo({ left: b.offsetLeft - (thumbsBox.clientWidth - b.offsetWidth) / 2, behavior: reduce ? 'auto' : 'smooth' });
        else if (thumbsBox.scrollHeight > thumbsBox.clientHeight + 2) thumbsBox.scrollTo({ top: b.offsetTop - (thumbsBox.clientHeight - b.offsetHeight) / 2, behavior: reduce ? 'auto' : 'smooth' });
      }
    }
    function show(i, instant) {
      if (!N) return;
      i = (i + N) % N; upd(i);
      var w = track.clientWidth; if (!w) return;
      if (instant || reduce) { track.style.scrollBehavior = 'auto'; track.scrollLeft = i * w; track.style.scrollBehavior = ''; return; }
      lock = i; clearTimeout(lockT); lockT = setTimeout(function () { lock = -1; }, 900);
      track.scrollTo({ left: i * w, behavior: 'smooth' });
    }
    var raf = 0;
    track.addEventListener('scroll', function () {
      if (raf) return;
      raf = requestAnimationFrame(function () {
        raf = 0;
        var w = track.clientWidth; if (!w) return;
        var i = Math.round(track.scrollLeft / w);
        if (lock > -1) { if (i === lock) lock = -1; else return; }
        if (i !== gi && i >= 0 && i < N) upd(i);
      });
    }, { passive: true });
    // closing the viewer on another photo first moves the gallery there, so the photo flies back into place
    function srcFn(i, closing) { if (closing && i !== gi) show(i, true); return slides[i]; }
    thumbsBox.addEventListener('click', function (e) { var b = e.target.closest('button'); if (b) show(+b.getAttribute('data-i')); });
    var pv = root.querySelector('.garr.prev'), nx = root.querySelector('.garr.next');
    if (pv) pv.addEventListener('click', function () { show(gi - 1); });
    if (nx) nx.addEventListener('click', function () { show(gi + 1); });
    // swipe or drag the main photo; only a tap without movement opens the viewer
    var drag = null, swiped = false;
    track.addEventListener('pointerdown', function (e) { swiped = false; drag = { x: e.clientX, y: e.clientY, s: track.scrollLeft, mouse: e.pointerType === 'mouse' && e.button === 0, moved: false }; });
    addEventListener('pointermove', function (e) {
      if (!drag) return;
      var dx = e.clientX - drag.x;
      if (!drag.moved) { if (Math.abs(dx) < 6 && Math.abs(e.clientY - drag.y) < 6) return; drag.moved = swiped = true; if (drag.mouse) { track.style.scrollSnapType = 'none'; track.style.scrollBehavior = 'auto'; } }
      if (drag.mouse) track.scrollLeft = drag.s - dx;
    });
    addEventListener('pointerup', function (e) {
      if (!drag) return; var d = drag; drag = null;
      if (!d.moved || !d.mouse) return;
      var dx = e.clientX - d.x, w = track.clientWidth, base = Math.round(d.s / w);
      track.style.scrollSnapType = ''; track.style.scrollBehavior = '';
      show(Math.max(0, Math.min(N - 1, Math.abs(dx) > w * 0.12 ? base + (dx < 0 ? 1 : -1) : base)));
    });
    addEventListener('pointercancel', function () { drag = null; track.style.scrollSnapType = ''; track.style.scrollBehavior = ''; });
    track.addEventListener('click', function (e) {
      if (swiped) { swiped = false; return; }
      var sl = e.target.closest('.gslide'); if (sl && SET[+sl.getAttribute('data-i')].src) openLB(SET, +sl.getAttribute('data-i'), track, srcFn);
    });
    track.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') { e.preventDefault(); show(gi + 1); }
      else if (e.key === 'ArrowLeft') { e.preventDefault(); show(gi - 1); }
      else if ((e.key === 'Enter' || e.key === ' ') && SET[gi] && SET[gi].src) { e.preventDefault(); openLB(SET, gi, track, srcFn); }
    });
    addEventListener('resize', function () { show(gi, true); });

    // the photo follows the choice: the engraved banner for engraving, the clean set without it
    var box7 = document.getElementById('whs7'), engOn = null;
    function syncEng(user) {
      var on = !!(box7 && box7.classList.contains('is-on'));
      root.classList.toggle('is-eng', on);
      if (engOn !== null && on !== engOn && user) {
        var k = +root.getAttribute(on ? 'data-eng-slide' : 'data-plain-slide');
        if (k >= 0 && k < N) show(k);
      }
      engOn = on;
    }
    if (box7 && window.MutationObserver) new MutationObserver(function () { syncEng(true); }).observe(box7, { attributes: true, attributeFilter: ['class'] });
    syncEng(false);

    // the engine's text fields follow the same one-line / two-line rule
    var sets = root.querySelector('[data-whs7-sets]');
    if (sets) {
      var fitAll = function () { all(sets, 'textarea').forEach(fitRows); };
      sets.addEventListener('input', function (e) { if (e.target.tagName === 'TEXTAREA') fitRows(e.target); });
      sets.addEventListener('click', function () { setTimeout(fitAll, 0); }); // an idea fills the field
      if (window.MutationObserver) new MutationObserver(fitAll).observe(sets, { childList: true });
      fitAll();
    }

    // clips under the photo (desktop): the hovered one plays, a click opens it larger
    var gvBox = root.querySelector('.gvids'), gvs = gvBox ? all(gvBox, '.gv') : [];
    if (gvs.length) {
      var GV = gvs.map(function (b) { return { video: true, src: b.getAttribute('data-src'), poster: b.getAttribute('data-poster'), snd: b.getAttribute('data-snd') === '1', cap: b.getAttribute('data-cap') || '', ar: 9 / 16 }; });
      var hov = -1, gvIn = false;
      var gvSync = function () {
        var shown = gvIn && gvBox.offsetParent !== null && !lbOpen() && !document.hidden && !reduce, a = hov > -1 ? hov : firstSeen();
        gvs.forEach(function (b, i) {
          var v = b.querySelector('video');
          b.classList.toggle('on', i === a);
          if (shown && i === a) {
            // the little window plays the light 6-second copy; if it is missing, the full clip
            var want = b.getAttribute('data-small') || GV[i].src;
            if (!v._fb) { v._fb = 1; v.addEventListener('error', function () { if (v.getAttribute('src') !== GV[i].src) { v.src = GV[i].src; var p2 = v.play(); if (p2 && p2.catch) p2.catch(function () {}); } }); }
            if (v.getAttribute('src') !== want && v.getAttribute('src') !== GV[i].src) { v.preload = 'metadata'; v.src = want; }
            var p = v.play(); if (p && p.catch) p.catch(function () {});
          } else if (!v.paused) v.pause();
        });
      };
      gvs.forEach(function (b, i) {
        b.addEventListener('pointerenter', function (e) { if (e.pointerType === 'mouse') { hov = i; gvSync(); } });
        b.addEventListener('focus', function () { hov = i; gvSync(); });
        b.addEventListener('click', function () { openLB(GV, i, b, function (j) { return gvs[j]; }); });
      });
      var row = gvBox.querySelector('.gv-row');
      // the arrows (or a swipe) move the strip by one screenful, the first clip in view plays
      var firstSeen = function () { var x = row.scrollLeft, k = 0; gvs.forEach(function (b, i) { if (b.offsetLeft - gvs[0].offsetLeft <= x + 4) k = i; }); return k; };
      // three clips fit on a wide screen, two on a narrow one (CSS container query); paging follows what fits
      var gvN = gvBox.querySelector('.gv-n'), per = function () { return Math.max(1, Math.round((row.clientWidth + 8) / 99)); };
      var gvPaint = function () { if (!gvN) return; var a = firstSeen(); gvN.textContent = (a + 1) + '–' + Math.min(gvs.length, a + per()) + ' / ' + gvs.length; };
      var gvGo = function (dir) {
        var a = firstSeen(), to = a + dir * per();
        if (to >= gvs.length) to = 0; else if (to < 0) to = Math.max(0, gvs.length - per()); // wraps around at both ends
        row.scrollTo({ left: gvs[to].offsetLeft - gvs[0].offsetLeft, behavior: reduce ? 'auto' : 'smooth' });
      };
      var gp = gvBox.querySelector('[data-gv-prev]'), gn = gvBox.querySelector('[data-gv-next]');
      if (gp) gp.addEventListener('click', function () { gvGo(-1); });
      if (gn) gn.addEventListener('click', function () { gvGo(1); });
      var gvT = 0;
      row.addEventListener('scroll', function () { clearTimeout(gvT); gvT = setTimeout(function () { gvPaint(); gvSync(); }, 120); }, { passive: true });
      row.addEventListener('pointerleave', function () { hov = -1; gvSync(); });
      row.addEventListener('focusout', function (e) { if (!row.contains(e.relatedTarget)) { hov = -1; gvSync(); } });
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { gvIn = es[0].isIntersecting; gvSync(); }, { threshold: 0.5 }).observe(gvBox);
      else gvIn = true;
      addEventListener('resize', function () { gvPaint(); gvSync(); });
      document.addEventListener('visibilitychange', gvSync);
      onLB(gvSync);
      gvPaint();
    }

    // other products: the chosen variant card sets the form's id, the prices, the button and the photo
    var vp = root.querySelector('[data-vpick]');
    if (vp) {
      // several options: the chosen value in every group picks the matching variant's hidden radio
      var vmapEl = vp.querySelector('[data-vmap]');
      if (vmapEl) {
        var vmap = JSON.parse(vmapEl.textContent);
        var groups = all(vp, '[data-optgroup]');
        var find = function (s) { return vmap.filter(function (v) { return v.o.every(function (x, i) { return x === s[i]; }); })[0]; };
        var current = function () { return groups.map(function (gg) { var r = gg.querySelector('input:checked'); return r ? r.value : null; }); };
        // every card shows its real price with the other choices kept; a choice that doesn't exist with them is dimmed
        var paint = function () {
          var sel = current();
          groups.forEach(function (gg, gi) {
            all(gg, 'input').forEach(function (inp) {
              var s = sel.slice(); s[gi] = inp.value;
              var v = find(s), lab = inp.closest('.opt, .chip'), b = lab && lab.querySelector('.t b');
              if (lab) lab.classList.toggle('is-na', !v);
              if (b) b.textContent = v ? v.p : '';
            });
          });
        };
        paint();
        groups.forEach(function (g) {
          g.addEventListener('change', function (e) {
            if (!e.target.name || e.target.name.indexOf('wh-opt-') !== 0) return;
            e.stopPropagation();
            all(g, '.opt, .chip').forEach(function (o) { o.classList.toggle('on', o.contains(e.target)); });
            var gi = groups.indexOf(g), hit = find(current());
            // the combination doesn't exist (e.g. a square glass only comes single): keep this choice, move the others to the first that does
            if (!hit) {
              hit = vmap.filter(function (v) { return v.o[gi] === e.target.value; })[0];
              if (!hit) return;
              groups.forEach(function (gg, j) {
                all(gg, 'input').forEach(function (inp) {
                  inp.checked = inp.value === hit.o[j];
                  var lab = inp.closest('.opt, .chip'); if (lab) lab.classList.toggle('on', inp.checked);
                });
                var lv = gg.previousElementSibling && gg.previousElementSibling.querySelector('[data-optval]');
                if (lv) lv.textContent = hit.o[j];
              });
            }
            var ov = g.previousElementSibling && g.previousElementSibling.querySelector('[data-optval]');
            if (ov) ov.textContent = e.target.value;
            paint();
            var r = vp.querySelector('input[name="wh-vpick"][value="' + hit.id + '"]');
            if (r) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
          });
        });
      }
      // a click on a joined card outside its small buttons picks the finish shown on it
      all(vp, '[data-grp]').forEach(function (g) {
        g.addEventListener('click', function (e) {
          if (e.target.closest('.chip')) return;
          var shown = g.querySelector('.grp-note:not([hidden])'), id = shown && shown.getAttribute('data-for');
          var r = g.querySelector('input[name="wh-vpick"][value="' + id + '"]') || g.querySelector('input[name="wh-vpick"]');
          if (r && !r.checked) r.click();
        });
      });
      var idIn = root.querySelector('.wh-rd-form [name="id"]'), atc0 = root.querySelector('.wh-rd-form .atc');
      vp.addEventListener('change', function (e) {
        var r = e.target.closest('input[name="wh-vpick"]'); if (!r || !idIn) return;
        idIn.value = r.value;
        all(vp, '.opts-flat .opt, .opts:not([data-optgroup]) .opt').forEach(function (o) { o.classList.toggle('on', o.contains(r)); });
        all(root, '.pprice .price, .wh-rd-form .atc .price, .sbar .price').forEach(function (p) { p.textContent = r.getAttribute('data-price'); });
        var ok = r.getAttribute('data-avail') === '1';
        all(root, '.price--pick').forEach(function (p) { p.classList.remove('price--pick'); });
        if (atc0) {
          atc0.disabled = !ok;
          var on = atc0.querySelector('.atc-on'), off = atc0.querySelector('.atc-off'), pk = atc0.querySelector('.atc-pick'), go = atc0.querySelector('.atc-go');
          if (on) on.hidden = !ok; if (off) off.hidden = ok;
          if (pk) pk.remove(); if (go) go.hidden = false;
        }
        // a joined card (one item in several finishes): its price, note and small buttons follow the chosen finish
        all(vp, '[data-grp]').forEach(function (g) {
          if (!g.contains(r)) return;
          all(g, '.chip').forEach(function (ch) { ch.classList.toggle('on', ch.contains(r)); });
          all(g, '.grp-note').forEach(function (n) { n.hidden = n.getAttribute('data-for') !== r.value; });
          var gp = g.querySelector('[data-grp-price]'); if (gp) gp.textContent = r.getAttribute('data-price');
        });
        var img = r.getAttribute('data-img');
        if (img) { for (var k = 0; k < N; k++) if (slides[k].getAttribute('data-img') === img) { show(k); break; } }
        if (history.replaceState) history.replaceState(history.state, '', location.pathname + '?variant=' + r.value);
      });
    }

    // phones: once the add-to-bag button has scrolled away, the bar at the bottom carries the price and the button
    var sbar = root.querySelector('.sbar'), atc = root.querySelector('.wh-rd-form .atc');
    if (sbar && atc) {
      var atcSeen = true;
      var updBar = function () {
        var on = narrow.matches && !atcSeen && atc.getBoundingClientRect().top < 0;
        if (sbar.hidden === on) { sbar.hidden = !on; document.body.classList.toggle('wh-rd-has-bar', on); }
      };
      if ('IntersectionObserver' in window) new IntersectionObserver(function (es) { atcSeen = es[0].isIntersecting; updBar(); }).observe(atc);
      onScroll(updBar);
      if (narrow.addEventListener) narrow.addEventListener('change', updBar);
      sbar.querySelector('[data-sbar-atc]').addEventListener('click', function () {
        // a blocked button (engraving text or the spelling tick missing) brings the panel into view instead
        if (atc.disabled) { var ok = document.querySelector('#whs7 .whs7-ok.is-wait') || document.getElementById('whs7') || atc; ok.scrollIntoView({ block: 'center', behavior: reduce ? 'auto' : 'smooth' }); return; }
        var f = atc.form;
        if (f.requestSubmit) f.requestSubmit(atc); else atc.click();
      });
    }
    upd(0);
  }

  // shop page: the cards rise in as they come into view, three at a time from left to right
  function initShop(root) {
    var grid = root.querySelector('[data-shop-grid]'); if (!grid) return;
    var cards = all(grid, '.pc');
    shopMenu(root, grid, cards);
    if (reduce || !('IntersectionObserver' in window)) return;
    // cards already on screen show straight away; only the ones further down rise in
    var fold = innerHeight * 0.95;
    cards.forEach(function (c) { if (c.getBoundingClientRect().top < fold) c.classList.add('is-in', 'no-rise'); });
    grid.classList.add('is-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var c = e.target; io.unobserve(c);
        c.style.transitionDelay = (cards.indexOf(c) % 5) * 70 + 'ms';
        c.classList.add('is-in');
      });
    }, { rootMargin: '0px 0px -8% 0px' });
    cards.forEach(function (c) { if (!c.classList.contains('no-rise')) io.observe(c); });
  }

  // shop page menu: room buttons show only that room's cards, the select orders them by price (or back to our order)
  function shopMenu(root, grid, cards) {
    var rooms = all(root, '.shop-room'), sel = root.querySelector('[data-shop-sort]');
    if (!rooms.length && !sel) return;
    cards.forEach(function (c, i) { c.setAttribute('data-i', i); });
    function show(room) {
      rooms.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-room') === room ? 'true' : 'false'); });
      cards.forEach(function (c) {
        var on = !room || c.getAttribute('data-room') === room;
        c.hidden = !on; if (on) c.classList.add('is-in', 'no-rise');
      });
    }
    rooms.forEach(function (b) { b.addEventListener('click', function () { show(b.getAttribute('data-room')); }); });
    if (sel) sel.addEventListener('change', function () {
      var v = sel.value, list = cards.slice();
      list.sort(function (a, b) {
        if (!v) return a.getAttribute('data-i') - b.getAttribute('data-i');
        var d = a.getAttribute('data-price') - b.getAttribute('data-price');
        return v === 'asc' ? d : -d;
      });
      list.forEach(function (c) { c.classList.add('is-in', 'no-rise'); grid.appendChild(c); });
    });
  }

  // pieces to scale: outlines draw in on scroll; the set buttons and the variant cards above stay in step
  function initPieces(root) {
    var box = root.querySelector('[data-pieces]'); if (!box) return;
    var rows = all(box, '.pcs-row'), btns = all(box, '[data-set]'), tot = box.querySelector('[data-pcs-total]');
    var apply = function (set) {
      var g = 0;
      btns.forEach(function (b) { b.setAttribute('aria-pressed', b.getAttribute('data-set') === set ? 'true' : 'false'); });
      rows.forEach(function (r) {
        var off = set === 'small' && r.getAttribute('data-in-small') !== '1';
        r.classList.toggle('is-off', off);
        if (!off) g += +r.getAttribute('data-g') || 0;
      });
      if (tot) tot.textContent = g;
      if (tray) tray.classList.toggle('is-off', set === 'small');
      var on = btns.filter(function (b) { return b.getAttribute('data-set') === set; })[0];
      if (on && price) { var pb = on.querySelector('b'); if (pb) price.textContent = pb.textContent; }
    };
    var tray = box.querySelector('[data-pcs-tray]'), price = box.querySelector('[data-pcs-price]'), atcP = box.querySelector('[data-pcs-atc]');
    // the tray sits under the upright pieces: span it from the first to the last drawing
    var placeTray = function () {
      if (!tray) return;
      var svgs = all(box, '.pcs-up .pcs-shape svg'); if (!svgs.length) return;
      var g = box.querySelector('.pcs-grid').getBoundingClientRect(), a = svgs[0].getBoundingClientRect(), z = svgs[svgs.length - 1].getBoundingClientRect();
      tray.style.left = (a.left - g.left - a.width * .25) + 'px';
      tray.style.width = (z.right - a.left + a.width * .5) + 'px';
      tray.style.top = (a.bottom - g.top - a.height * .035) + 'px';
    };
    if (tray) { placeTray(); window.addEventListener('resize', placeTray); if (document.fonts && document.fonts.ready) document.fonts.ready.then(placeTray); setTimeout(placeTray, 600); }
    if (atcP) atcP.addEventListener('click', function () {
      var main = document.querySelector('.wh-rd-form .atc'); if (main && !main.disabled) main.click();
    });
    btns.forEach(function (b) {
      b.addEventListener('click', function () {
        apply(b.getAttribute('data-set'));
        var r = document.querySelector('input[name="wh-vpick"][value="' + b.getAttribute('data-v') + '"]');
        if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); }
      });
    });
    document.addEventListener('change', function (e) {
      var r = e.target; if (!r || r.name !== 'wh-vpick') return;
      btns.forEach(function (b) { if (b.getAttribute('data-v') === r.value) apply(b.getAttribute('data-set')); });
    });
    if (reduce || !('IntersectionObserver' in window)) return;
    box.classList.add('is-anim');
    var io = new IntersectionObserver(function (es) {
      es.forEach(function (e) {
        if (!e.isIntersecting) return;
        var r = e.target; io.unobserve(r);
        setTimeout(function () { r.classList.add('is-in'); }, (rows.indexOf(r) % 5) * 160);
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    rows.forEach(function (r) { io.observe(r); });
  }

  // steps with photos: the step in the middle of the screen lights up, its photo shows, the line fills with the scroll
  function initSteps(root) {
    var box = root.querySelector('[data-steps]'); if (!box) return;
    var list = box.querySelector('.stp-list'), items = all(box, '.stp-list > li'), figs = all(box, '.stp-media figure');
    var setOn = function (k) {
      items.forEach(function (li, i) { li.classList.toggle('on', i === k); });
      figs.forEach(function (f, i) { f.classList.toggle('on', i === k); });
    };
    if ('IntersectionObserver' in window) {
      var io = new IntersectionObserver(function (es) {
        es.forEach(function (e) { if (e.isIntersecting) setOn(items.indexOf(e.target)); });
      }, { rootMargin: '-45% 0px -45% 0px' });
      items.forEach(function (li) { io.observe(li); });
    }
    if (reduce) return;
    box.classList.add('is-anim');
    onScroll(function () {
      var r = list.getBoundingClientRect(), mid = window.innerHeight / 2;
      var p = Math.min(1, Math.max(0, (mid - r.top) / Math.max(1, r.height)));
      list.style.setProperty('--p', p.toFixed(3));
    });
  }

  // home: links marked data-smooth glide to their #anchor; the facts row counts up once it is seen
  function initHome(root) {
    all(root, 'a[data-smooth]').forEach(function (a) {
      a.addEventListener('click', function (e) {
        var id = (a.getAttribute('href') || '').split('#')[1], el = id && document.getElementById(id);
        if (!el) return;
        e.preventDefault();
        el.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
      });
    });
    all(root, '.fct').forEach(function (box) {
      var go = function () {
        box.classList.add('is-in');
        if (reduce) return;
        all(box, '[data-fct]').forEach(function (el) {
          var raw = el.getAttribute('data-fct'); if (!/^\d+$/.test(raw)) return; var to = +raw; if (to <= 0) return;
          var t0 = null, step = function (t) { t0 = t0 || t; var k = Math.min(1, (t - t0) / 1200); el.textContent = Math.round(to * (1 - Math.pow(1 - k, 3))); if (k < 1) requestAnimationFrame(step); };
          el.textContent = '0'; requestAnimationFrame(step);
        });
      };
      if (!('IntersectionObserver' in window)) return go();
      var io = new IntersectionObserver(function (es) { if (es[0].isIntersecting) { io.disconnect(); go(); } }, { threshold: .3 });
      io.observe(box);
    });
  }

  // scroll scenes: the section is several screens tall; scroll turns into --s0, --s1 … (0 → 1 for each step)
  function initScrub(root) {
    all(root, '[data-scrub]').forEach(function (box) {
      var caps = all(box, '.scr-caps > li'), dots = all(box, '.scr-dots i'), counts = all(box, '[data-count]');
      var n = Math.max(1, caps.length), last = -1;
      if (reduce) {
        box.classList.add('is-static');
        for (var j = 0; j < n; j++) box.style.setProperty('--s' + j, '1');
        counts.forEach(function (c) { c.textContent = (+c.getAttribute('data-to')).toLocaleString('en-US'); });
        return;
      }
      var upd = function () {
        var r = box.getBoundingClientRect(), span = Math.max(1, r.height - window.innerHeight);
        if (r.bottom < -200 || r.top > window.innerHeight + 200) return;
        var p = Math.min(1, Math.max(0, -r.top / span)), k = Math.min(n - 1, Math.floor(p * n));
        for (var i = 0; i < n; i++) {
          var s = Math.min(1, Math.max(0, p * n - i));
          box.style.setProperty('--s' + i, s.toFixed(3));
          if (dots[i]) dots[i].style.setProperty('--d', s.toFixed(3));
        }
        if (k !== last) { caps.forEach(function (c, i) { c.classList.toggle('on', i === k); }); last = k; }
        counts.forEach(function (c) {
          var st = +c.getAttribute('data-stage') || 0, s = Math.min(1, Math.max(0, p * n - st));
          c.textContent = Math.round(s * (+c.getAttribute('data-to'))).toLocaleString('en-US');
        });
      };
      onScroll(upd); window.addEventListener('resize', upd); upd();
    });
  }

  // titles marked data-fit-line stay on one line: the font shrinks until the title fits its column
  function fitLines(root) {
    all(root, '[data-fit-line]').forEach(function (el) {
      var fit = function () {
        el.style.fontSize = ''; el.style.whiteSpace = 'nowrap';
        var max = parseFloat(getComputedStyle(el).fontSize), w = el.clientWidth, sw = el.scrollWidth;
        if (sw > w && w > 0) el.style.fontSize = Math.max(22, Math.floor(max * w / sw * 0.98)) + 'px';
        if (el.scrollWidth > el.clientWidth) el.style.whiteSpace = '';
      };
      fit();
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(fit);
      window.addEventListener('resize', fit);
    });
  }

  /* ---------- start ---------- */
  function init(scope) {
    all(scope, '[data-wh-rd]').forEach(function (root) {
      if (root.dataset.whRdOn) return; root.dataset.whRdOn = '1';
      initRing(root); initRail(root); initShards(root); initReveal(root); initSlices(root);
      initDiff(root); initVideos(root); initEngrave(root); initDeck(root); initHeader(root); initProduct(root); initShop(root); initPieces(root); initSteps(root); initScrub(root); initHome(root); fitLines(root);
    });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
  // the header language list closes on a click elsewhere or on Escape
  document.addEventListener('click', function (e) { all(document, '.lang-dd[open]').forEach(function (d) { if (!d.contains(e.target)) d.open = false; }); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') all(document, '.lang-dd[open]').forEach(function (d) { d.open = false; }); });
  window.whRdOpenViewer = openLB; // used by the product page photo strip
})();
